import React from 'react'
import { useHistory, useRouteMatch } from 'react-router'

import { AlergiaReacaoModel } from '../../avaliacao/components/alergias-reacoes/model'
import { AsideSection } from '../AsideSection'
import { AlergiasCard } from './AlergiasCard'

export interface ProblemasSectionProps {
  prontuarioId: ID
  alergiasAvaliadas: AlergiaReacaoModel[]
}

export function AlergiasSection(props: ProblemasSectionProps) {
  const history = useHistory()
  const match = useRouteMatch()

  const handleClick = () => history.push(`${match.url}/lista-alergias`)
  return (
    <AsideSection
      title='Alergias/Reações adversas'
      tooltip='Ver todas as alergias/reações adversas'
      onClick={handleClick}
    >
      <AlergiasCard {...props} />
    </AsideSection>
  )
}
